module.exports = __webpack_public_path__ + "static/fscs-logo-old-67e2971023d1233bb184518ba86612ad.png";